export default __webpack_public_path__ + "static/media/(66).a5693353.jpg";